import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login");
      return;
    }
    const session_id = m[1];
    (async () => {
      try {
        await api.post("/auth/session", { session_id });
        await refresh();
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard");
      } catch {
        nav("/login");
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50">
      <div className="flex items-center gap-3 text-zinc-600">
        <Loader2 className="w-5 h-5 animate-spin" />
        Loggar in...
      </div>
    </div>
  );
}
